import CodusertypeList from './views/CodusertypeList'
import CodusertypeEdit from './views/CodusertypeEdit'
import CodusertypeCreate from './views/CodusertypeCreate'

export default {
  name:"codusertypes",
  list:CodusertypeList,
  edit:CodusertypeEdit,
  create:CodusertypeCreate,
}